import { SvgIcon } from "@mui/material";
import React from "react";

const EditWithBorderIcon = (props) => (
  <SvgIcon
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 0.6C0 0.268632 0.268632 0 0.6 0H6V1.2H1.2V10.8H10.8V6H12V11.4C12 11.7314 11.7314 12 11.4 12H0.6C0.268632 12 0 11.7314 0 11.4V0.6Z"
      fill="currentColor"
    />
    <path
      d="M12.0007 1.7561L10.2446 0L9.08838 1.15622L10.8445 2.91232L12.0007 1.7561Z"
      fill="currentColor"
    />
    <path
      d="M4.80029 7.20013L6.73199 7.02451L9.99551 3.76098L8.23943 2.00488L4.97591 5.26843L4.80029 7.20013Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default EditWithBorderIcon;
